"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tabs = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const TabButton_1 = require("./TabButton");
const Tabs = ({ links, actionLinks }) => {
    return ((0, jsx_runtime_1.jsx)("div", { className: "border-bottom border-3 ", children: (0, jsx_runtime_1.jsxs)("div", { className: "d-flex gap-3 justify-content-start flex-nowrap overflow-auto", style: { marginBottom: -3 }, children: [links.map(item => ((0, jsx_runtime_1.jsx)(TabButton_1.TabButton, { ...item }, item.label))), actionLinks && ((0, jsx_runtime_1.jsx)("span", { className: "ms-auto d-flex gap-3", children: actionLinks.map(item => ((0, jsx_runtime_1.jsx)(TabButton_1.TabButton, { ...item }, item.label))) }))] }) }));
};
exports.Tabs = Tabs;
